'use client';

import { useCallback } from 'react';

import { usePostGameUpsell } from '@/components/PostGameUpsellModal';
import { upsellOffers } from '@/utils';

import { usePromotionOffers } from './usePromotionOffers';

type UseEndOfGameOfferParams = {
  raffleId: string | undefined;
  gameTitle: string;
  onNoOffer: () => void;
};

type UseEndOfGameOfferReturn = {
  showEndOfGameOffer: () => void;
};

export const useEndOfGameOffer = ({
  raffleId,
  gameTitle,
  onNoOffer,
}: UseEndOfGameOfferParams): UseEndOfGameOfferReturn => {
  const state = usePromotionOffers({ raffleId });
  const { showPostGameUpsell } = usePostGameUpsell();

  const showEndOfGameOffer = useCallback(() => {
    if (state.status !== 'unified') return onNoOffer();
    if (!state.isOnSale) return onNoOffer();
    if (!state.ticketPrice) return onNoOffer();
    if (!raffleId) return onNoOffer();

    const offers = upsellOffers(state.offers);
    const offer = offers[0];

    if (!offer) return onNoOffer();

    return showPostGameUpsell({
      raffleId,
      raffleName: state.raffleName,
      offer,
      ticketPrice: state.ticketPrice,
      gameTitle,
    });
  }, [state, raffleId, gameTitle, onNoOffer, showPostGameUpsell]);

  return { showEndOfGameOffer };
};
